import axios from "axios"
import _ from "lodash"
import * as actionType from "../actions/actionTypes"
const isBrowser = typeof window !== `undefined`
export const authStart = () => {
  return {
    type: actionType.AUTH_START,
  }
}

export const loadingStart = () => {
  return {
    type: actionType.LOADING_START,
  }
}

export const loadingStop = () => {
  return {
    type: actionType.LOADING_STOP,
  }
}

export const authSuccess = () => {
  return {
    type: actionType.AUTH_SUCCESS,
  }
}
export const userUpdated = () => {
  return {
    type: actionType.USER_UPDATED,
  }
}

export const authRegistration = () => {
  return {
    type: actionType.AUTH_REGISTRATION,
  }
}

export const authFail = error => {
  return {
    type: actionType.AUTH_FAIL,
    error: error,
  }
}
export const authUpdate = () => {
  return {
    type: actionType.AUTH_SUCCESS,
  }
}

export const authLogout = () => {
  return {
    type: actionType.AUTH_LOGOUT,
  }
}
export const actionFail = error => {
  return {
    type: actionType.ACTION_FAIL,
    error: error,
  }
}

export const stateUserUUID = () => {
  return {
    type: actionType.SET_UUID,
  }
}
export const avatorFormOpen = (openStatus = false) => {
  return {
    type: actionType.AVATOR_FORM_OPEN,
    payload: openStatus,
  }
}

export const formOpen = value => {
  return {
    type: actionType.FORM_OPEN,
    payload: value,
  }
}
export const formSummeryOpen = value => {
  return {
    type: actionType.FORM_SUMMERY_OPEN,
    payload: value,
  }
}

export const profileTabActive = (
  activeTab = actionType.PROFILE_TAB_DEFAULT
) => {
  return {
    type: actionType.PROFILE_TAB_ACTIVE,
    payload: activeTab,
  }
}
export const userLogout = callback => {
  return dispatch => {
    dispatch(loadingStart())
    destroyAuthSession()
    dispatch(authLogout())
    setTimeout(() => {
      callback()
    }, 2000)
  }
}
export const userLogin = (email, password) => {
  return dispatch => {
    dispatch(authStart())

    const userData = { name: email, pass: password }
    console.log(userData)
    axios
      .post(actionType.BACKEND_WEB + "/user/login?_format=json", userData)
      .then(responce => {
        var credentials = btoa(email + ":" + password)
        basicCredentials(credentials)
        console.log(responce.data)
        setUser(responce.data)
        dispatch(fetchAvatorImage(responce.data.current_user.uuid))
        dispatch(setUserUUID(responce.data.current_user.uuid))
      })
      .catch(err => {
        let errorResponse = err
        dispatch(authFail(errorResponse))
        console.log(err)
      })
  }
}

export const fetchUserData = uuid => {
  return dispatch => {
    axios
      .get(actionType.API_PATH + "/users/" + uuid)
      .then(responce => {
        setUserData(responce.data)
        dispatch(userUpdated())
        dispatch(authSuccess())
      })
      .catch(err => {
        let errorResponse = err
        dispatch(authFail(errorResponse))
        console.log(err)
      })
  }
}

export const fetchAvatorImage = uuid => {
  return dispatch => {
    dispatch(loadingStart())
    axios
      .get(actionType.API_PATH + "/users/" + uuid + "/userPicture")
      .then(responce => {
        const avatorUrl = _.get(responce, "data.data.attributes.uri.url")
        setAvatorImage(actionType.BACKEND_WEB + avatorUrl)
        dispatch(avatorFormOpen())
      })
      .catch(err => {
        let errorResponse = err
        dispatch(actionFail(errorResponse))
        console.log(err)
      })
  }
}
//user REgistration
/**
 * User Registration
 */
export const userRegistration = userObject => {
  return dispatch => {
    dispatch(loadingStart())
    axios
      .post("/user/register?_format=json", userObject)
      .then(responce => {
        console.log("user Registration-", responce)
        dispatch(authRegistration())
      })
      .catch(err => {
        let errorResponse = err
        dispatch(authFail(errorResponse))
        console.log(err)
      })
  }
}

export const userUpdate = (userObject, uid_uuid = "") => {
  //console.log(axios.defaults.headers)
  if (!uid_uuid) {
    const uid_uuid = getUser("id")
  }
  return dispatch => {
    dispatch(loadingStart())

    const axiosPatchConfig = {
      headers: axios.defaults.headers.patch,
    }
    axios
      .patch(
        actionType.API_PATH + "/users/" + uid_uuid,
        userObject,
        axiosPatchConfig
      )
      .then(responce => {
        setUserData(responce.data)
        dispatch(formOpen(false))
        dispatch(authUpdate())
      })
      .catch(err => {
        console.log("TCL: userUpdate -> err", err)
        dispatch(authFail("not update error"))
        // console.log(errorResponse)
      })
  }
}

export const userUpdateAvator = (userObject, uid_uuid = "") => {
  //console.log(axios.defaults.headers)
  if (!uid_uuid) {
    const uid_uuid = getUser("id")
  }
  return dispatch => {
    dispatch(loadingStart())

    const axiosPatchConfig = {
      headers: axios.defaults.headers.patch,
    }
    axios
      .patch(
        actionType.API_PATH + "/users/" + uid_uuid,
        userObject,
        axiosPatchConfig
      )
      .then(responce => {
        dispatch(fetchAvatorImage(uid_uuid))
      })
      .catch(err => {
        console.log("TCL: userUpdate -> err", err)
        dispatch(authFail("not update error"))
        // console.log(errorResponse)
      })
  }
}

const prepaireAvatorUpdateObject = (img_uuid, user_uuid) => {
  return {
    data: {
      type: "users",
      id: user_uuid,
      relationships: {
        userPicture: {
          data: {
            id: img_uuid,
            type: "file--image",
          },
          links: {
            related: actionType.API_PATH + `users/${user_uuid}/userPicture`,
            self:
              actionType.API_PATH +
              `users/${user_uuid}/relationships/userPicture`,
          },
        },
      },
    },
  }
}

export const userAvatorUpdate = (data, uid_uuid) => {
  return dispatch => {
    dispatch(loadingStart())
    const axiosConfig = {
      headers: {
        "Content-Type": "application/octet-stream",
        "Content-Disposition": `file; filename="${data["fileName"]}"`,
        Accept: "application/vnd.api+json",
      },
    }
    //  console.log(axiosConfig)
    const RestUrl =
      actionType.BACKEND_WEB +
      "/file/upload/user/user/user_picture?_format=json"
    axios
      .post(RestUrl, data["fileUploadData"], axiosConfig)
      .then(responce => {
        const file_uuid = _.get(responce, "data.uuid.0.value")
        console.log("file_uuid--", file_uuid)
        if (file_uuid) {
          const userData = prepaireAvatorUpdateObject(file_uuid, uid_uuid)
          dispatch(userUpdateAvator(userData, uid_uuid))
        } else {
          dispatch(actionFail("Error: issue in update. Try again"))
          console.log("Error: issue in update. Try again")
        }
      })
      .catch(err => {
        console.log(err)
        dispatch(actionFail("Error: File is not uplaoding. Try again"))
      })
  }
}
/**
 * Local Store user Basic Credentials
 */
const basicCredentials = basic_credentials => {
  if (basic_credentials) {
    localStorage.setItem("basic_credentials", basic_credentials)
  } else {
    localStorage.removeItem("basic_credentials")
    delete axios.defaults.headers.patch
    console.log("Remove basic_credentials")
  }
}

///////

/**
 * set user data
 */
const setUser = loginObj => {
  if (loginObj) {
    const { access_token, csrf_token, current_user, logout_token } = loginObj
    setCsrfToken(csrf_token)
    setLoggedInUser(current_user)
    setSession(access_token)
    setLogoutToken(logout_token)
    return true
  }
}

/**
 * Local Store user access_token
 */
const setSession = access_token => {
  if (access_token) {
    localStorage.setItem("access_token", access_token)
    axios.defaults.headers.common["Authorization"] = "JWT " + access_token
  } else {
    localStorage.removeItem("access_token")
    delete axios.defaults.headers.common["Authorization"]
    console.log("Remove access_token")
  }
}
export const getSession = () => {
  if (!isBrowser) return false
  const accessToken = localStorage.getItem("access_token")
  return accessToken
}

/**
 * Local Store user csrf_token
 */
const setCsrfToken = csrf_token => {
  if (csrf_token) {
    localStorage.setItem("csrf_token", csrf_token)
    axios.defaults.headers.common["X-CSRF-Token"] = csrf_token
  } else {
    localStorage.removeItem("csrf_token")
    delete axios.defaults.headers.common["X-CSRF-Token"]
  }
}

/**
 * Local Store user logout_token
 */
const setLogoutToken = logout_token => {
  if (logout_token) {
    localStorage.setItem("logout_token", logout_token)
  } else {
    localStorage.removeItem("logout_token")
  }
}

/**
 * Local Store user data
 */
const setLoggedInUser = loggedInUser => {
  if (loggedInUser) {
    localStorage.setItem("loggedInUser", JSON.stringify(loggedInUser))
  } else {
    localStorage.removeItem("loggedInUser")
    console.log("Remove loggedInUser")
  }
}

/**
 * Local Store user data
 */
export const setUserUUID = uuid => {
  return dispatch => {
    if (uuid) {
      localStorage.setItem("uuid", uuid)
      dispatch(stateUserUUID())
      dispatch(fetchUserData(uuid))
    } else {
      console.log("UUID is missing. Loggin fail")
    }
  }
}

/**
 * Local Store user data
 */
const removeUserUUID = () => {
  localStorage.removeItem("uuid")
}
/**
 * Local Store user data
 */
export const getUUID = () => {
  if (!isBrowser) return false
  const uuid = window.localStorage.getItem("uuid")
  if (uuid) {
    return uuid
  } else {
    console.log("UUID not define")
    return null
  }
}

/**
 * Local Store user data
 */
const setAvatorImage = avatorUrl => {
  if (avatorUrl) {
    localStorage.setItem("AvatorUrl", avatorUrl)
  } else {
    localStorage.removeItem("AvatorUrl")
  }
}
/**
 * Local Store user data
 */
export const getAvatorImage = () => {
  if (!isBrowser) return false
  return localStorage.getItem("AvatorUrl")
}
/**
 * Local Store user data
 */
const setUserData = userObject => {
  if (userObject) {
    localStorage.setItem("userObject", JSON.stringify(userObject))
  } else {
    localStorage.removeItem("userObject")
  }
}

/**
 * Local Store user data
 */
export const getUserData = () => {
  if (!isBrowser) return false
  const userObject = window.localStorage.getItem("userObject")
  return userObject ? JSON.parse(userObject) : null
}

/**
 * User logout and destroy user session
 */
export const destroyAuthSession = () => {
  //if (!isBrowser) return
  setCsrfToken("")
  setLoggedInUser({})
  setUserData("")
  setSession("")
  setLogoutToken("")
  basicCredentials("")
  removeUserUUID("")
  setAvatorImage("")
}
